export const getVMP = async function () {
  const { getVMP } = await import('@luxottica/vmp')
  return getVMP()
}
